export default __webpack_public_path__ + "static/media/196.b8588aa9.png";